export const userHasPermission = (user, key) => {
  const isMainUser = user?.isMainAccess;
  if (isMainUser) return true
  
  const hasAccess = user?.companyUser?.companyUserPermissions.some(p => p.key === key);
  return hasAccess;
};